import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '数据库实例',
    type: 'VR_DEPLOYED_DBINS',
}
